<template>
  <section class="container">
    <el-form
      label-width="150px"
      label-position="left"
      class="form-class">
      <el-form-item label="标题">
        <el-input v-model="editObject.carousel_title"/>
      </el-form-item>
      <el-form-item label="英文标题">
        <el-input v-model="editObject.carousel_english_title"/>
      </el-form-item>
      <el-form-item label="跳转链接">
        <el-input v-model="editObject.carousel_url"/>
      </el-form-item>
      <el-form-item label="权重">
        <el-input-number
          v-model="editObject.carousel_sort"
          :min="1" />
          <!-- <el-input
          type="number"
          v-model="editObject.carousel_sort"/> -->
      </el-form-item>
      <el-form-item label="图片">
        <el-upload
          class="avatar-uploader"
          :action="uploadDomain"
          :data="uploadData"
          :on-success="uploadSuccess"
          :show-file-list="false">
          <img
            v-if="editObject.carousel_img"
            :src="qiniuDomain + editObject.carousel_img"
            class="avatar">
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"/>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          plain
          @click="onSave">保存</el-button>
      </el-form-item>
    </el-form>

  </section>
</template>

<script>
import getQiniuInfo from '@/api/api'
import env from '@/configs/env'
import {
  slideshowDetail, editSlideshow,
} from '@/api/slideshow'

export default {
  data() {
    return {
      uploadDomain: env.uploadDomain,
      uploadData: {
        token: '',
      },
      qiniuDomain: '',
      editObject: { //  根据接口来的命名，不是很喜欢---
        carousel_title: '',
        carousel_url: '',
        carousel_img: '',
        carousel_sort: '',
      },
    };
  },

  created() {
    this.network().getQiniuInfo()
    this.network().slideshowDetail()
  },
  methods: {
    uploadSuccess(res) {
      this.editObject.carousel_img = res.hash
    },
    onSave() {
      if (!this.event().inputVerify()) {
        return
      }
      this.network().editSlideshow()
    },
    event() {
      return {
        inputVerify: () => {
          if (!this.editObject.carousel_title) {
            this.$message('标题不能为空')
            return false
          }
          if (!this.editObject.carousel_english_title) {
            this.$message('英文标题不能为空')
            return false
          }
          if (!this.editObject.carousel_sort) {
            this.$message('权重不能为空')
            return false
          }
          if (!this.editObject.carousel_img) {
            this.$message('请先上传图片')
            return false
          }
          return true
        },
      }
    },
    network() {
      return {
        getQiniuInfo: async () => {
          const { status, data } = await getQiniuInfo()
          if (status === 200) {
            this.uploadData.token = data.token
            this.qiniuDomain = data.BucketDomain
          }
        },
        editSlideshow: async () => {
          const { status } = await editSlideshow(this.editObject)
          if (status === 200) {
            this.$message({
              message: '更新成功',
              type: 'success',
            })
          }
        },
        slideshowDetail: async () => {
          const { status, data } = await slideshowDetail({
            uuid: this.$route.params.uuid,
          })
          if (status === 200) {
            this.editObject = data
          }
        },
      }
    },
  },
};
</script>

<style scoped>
.btn-group {
  margin-bottom: 20px;
  text-align: right;
}
.add-btn {
    margin-left: auto;
  }
.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed #d9d9d9;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form {
    padding: 50px;
    width: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/vuepage/slideshow/edit.vue